export const DISCLAIMER_MODAL_COUNTRY_SELECT_TEST_ID = "disclaimer-modal-country-select";
export const DISCLAIMER_MODAL_ACCEPT_TEST_ID = "disclaimer-modal-accept";
export const DISCLAIMER_MODAL_CANCEL_TEST_ID = "disclaimer-modal-cancel";
export const DISCLAIMER_MODAL_ACCEPT_SUGGESTED_COUNTRY_TEST_ID = "disclaimer-modal-accept-suggested-country";
